import { z } from 'zod';

/** Admin-managed legal/info pages (System > Content). Stored as rich-text-ish HTML/markdown body. */
export const legalPageSchema = z.object({
  title: z.string().min(1).max(160).trim(),
  body: z.string().max(50_000),
});
export type LegalPageInput = z.infer<typeof legalPageSchema>;

export const faqItemSchema = z.object({
  id: z.string().uuid().optional(),
  question: z.string().min(1).max(300).trim(),
  answer: z.string().min(1).max(4000),
  sortOrder: z.number().int().min(0).max(9999).default(0),
});
export type FaqItemInput = z.infer<typeof faqItemSchema>;

export const faqContentSchema = z.object({
  items: z.array(faqItemSchema).max(200).default([]),
});
export type FaqContentInput = z.infer<typeof faqContentSchema>;

/** Storefront contact page + footer, replacing hardcoded values. */
export const contactInfoSchema = z.object({
  email: z.string().email().max(254),
  phone: z.string().max(30).optional().default(''),
  addressLine1: z.string().max(160).optional().default(''),
  addressLine2: z.string().max(160).optional().default(''),
  city: z.string().max(80).optional().default(''),
  state: z.string().max(80).optional().default(''),
  postalCode: z.string().max(20).optional().default(''),
  country: z.string().max(80).optional().default(''),
  hours: z.string().max(300).optional().default(''),
  mapUrl: z.string().url().optional().or(z.literal('')).default(''),
});
export type ContactInfoInput = z.infer<typeof contactInfoSchema>;
